import {
  EMI_TRANSACTION_FETCH_REQUEST,
  EMI_TRANSACTION_FETCH_REQUEST_SUCCESS,
  EMI_TRANSACTION_FETCH_REQUEST_FAILURE,
  EMI_TRANSACTION_CLEAN_REQUEST,
  EMI_TRANSACTION_UPDATE_REQUEST,
  EMI_TRANSACTION_UPDATE_REQUEST_SUCCESS,
  EMI_TRANSACTION_UPDATE_REQUEST_FAILURE,
  BNPL_LIST_FETCH_REQUEST,
  BNPL_LIST_FETCH_REQUEST_SUCCESS,
  BNPL_LIST_FETCH_REQUEST_FAILURE,
  BNPL_LIST_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const BNPL_LIST_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
    nextCursorId: null,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const emiTransactionReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case EMI_TRANSACTION_FETCH_REQUEST:
    case EMI_TRANSACTION_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case EMI_TRANSACTION_FETCH_REQUEST_SUCCESS:
    case EMI_TRANSACTION_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case EMI_TRANSACTION_FETCH_REQUEST_FAILURE:
    case EMI_TRANSACTION_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case EMI_TRANSACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

const bnplListReducer = (state, action) => {
  state = state || BNPL_LIST_INITIAL_STATE;
  switch (action.type) {
    case BNPL_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BNPL_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload:
          action.data.currentPage > 1
            ? [...state.payload, ...action.data.records]
            : [...action.data.records],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          nextCursorId: action.data.nextCursorId,
          showSizeChanger: true,
        },
      });

    case BNPL_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BNPL_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });
    default:
      return state;
  }
};

export { emiTransactionReducer, bnplListReducer };
